import { get } from 'lodash';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { callFlutterHandler } from '../utils/flutterBridge';
// import { useUrlFilters } from '../scenes/OffersPage/offers.utils';

export const useIdHash = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const paramsObject = Object.fromEntries(searchParams.entries());
  const custId = get(paramsObject, 'cid', '');
  const hash = get(paramsObject, 'customer-hash', '');
  const app = get(paramsObject, 'app', 0);
  const selected = get(paramsObject, 'selected', '') || false;
  const type = get(paramsObject, 'type', '');
  const latitude = get(paramsObject, 'latitude', '');
  const longitude = get(paramsObject, 'longitude', '');
  const unique_id = get(paramsObject, 'unique_id', '');
  const app_version = get(paramsObject, 'app_version', '');
  const app_version2 = get(paramsObject, 'app-version', '');
  const build_version = get(paramsObject, 'build_version', '');
  const build_version2 = get(paramsObject, 'build-version', '');
  const os = get(paramsObject, 'os', '');
  const version = get(paramsObject, 'version', '');
  const device_id = get(paramsObject, 'device-id', '');
  const firebase_id = get(paramsObject, 'firebase-id', '');
  const customerId = get(paramsObject, 'customerId', '');
  const customerHash = get(paramsObject, 'customerHash', '');

  let cId = custId || customerId;
  let hashValue = hash || customerHash;
  let isApp = parseInt(app);
  return {
    custId: cId,
    hash: hashValue,
    isApp,
    selected,
    //
    type,
    latitude,
    longitude,
    unique_id,
    app_version,
    app_version2,
    build_version,
    build_version2,
    os,
    version,
    device_id,
    firebase_id,
    //
  };
};

export const useNavigateRoute = () => {
  const navigate = useNavigate();
  const { custId: cid, hash, isApp } = useIdHash();
  let stack = JSON.parse(localStorage.getItem('routerStack') || '[]');
  const pathname = window.location.pathname;

  return ({
    nextPage = '',
    goBack = false,
    state = {},
    avoidNavigation = false,
    replace = false,
  }) => {
    let querySeparator = nextPage?.includes('?') ? '&' : '?';
    const baseQueries = `cid=${cid}&customer-hash=${hash}&app=${isApp}`;
    if (!goBack) {
      if (stack?.length === 0) {
        if (!pathname || pathname === '/') {
          stack.push('/');
        } else {
          stack.push(`${pathname.replace(/\/$/, '')}`);
        }
      }
      if (stack[0] === '/filters') {
        stack.shift();
        stack.push('/');
      }
      const rootPathParsed = nextPage.split('?')[0].replace(/\/$/, '');
      const sameIndex = stack.findIndex(
        (item) =>
          item.includes(rootPathParsed) && rootPathParsed.startsWith('/offers'),
      );
      if (sameIndex >= 0) {
        stack[sameIndex] = nextPage;
      } else {
        if (replace) {
          stack[stack.length - 1] = nextPage;
        } else {
          stack.push(nextPage);
        }
      }
      if (!isApp) {
        navigate(`${nextPage}${querySeparator}${baseQueries}`, {
          state,
          replace,
        });
      } else {
        window.location.href = `${nextPage}${querySeparator}${baseQueries}`;
      }
    } else {
      stack.pop();
      if (!avoidNavigation) {
        if (stack.length === 0) {
          if (isApp) {
            // window?.Flutter?.postMessage('backButton');
            callFlutterHandler('backButton');
          } else {
            navigate(`/?${baseQueries}`, { state });
          }
        } else {
          const lastPageRoute = stack[stack?.length - 1];
          const separator = lastPageRoute.includes('?') ? '&' : '?';
          navigate(`${lastPageRoute}${separator}${baseQueries}`, { state });
        }
      }
    }
    localStorage.setItem('routerStack', JSON.stringify(stack));
  };
};
